module.exports = __webpack_public_path__ + "img/37.0ff4fcd2.jpg";